export default __webpack_public_path__ + "static/media/logoMenu.dd92aa4e.svg";